import React, { useEffect, useState } from "react";

import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import { setInsuranceList } from "../../../../infra/aggregates/myProfile/insuranceAggregates/insuranceListSlice";
import { setExpiredInsuranceList } from "../../../../infra/aggregates/myProfile/insuranceAggregates/expiredInsuranceSlice";

import toast from "react-hot-toast";
import { insuranceServices } from "../../../../api/services/insuranceServices";
import DTOAddInsurance from "./DTOAddInsurance";
import AddInsurancePresenter from "./AddInsurancePresenter";
import { dependentsServices } from "../../../../api/services/dependentsServices";
import { setAlldependentslist } from "../../../../infra/aggregates/myProfile/DependentsAggregates/dependentslistSlice";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  insuranceList: any;
  mainModel: any;
  trans?: any;
}

const AddInsuranceController = ({
  isModalOpen,
  closeModal,
  insuranceList,
  mainModel,
  trans,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.authSlice);
  const storeInsurances: any = useAppSelector(
    (state) => state.insuranceListSlice?.insuranceList
  );
  const storeExpiredInsurances: any = useAppSelector(
    (state) => state.expiredInsuranceSlice?.expiredInsurance
  );

  const [allInsurers, setAllInsurers] = useState([]);
  const [allPolicies, setAllPolicies] = useState([]);

  const dispatch = useAppDispatch();

  const getData = (data: any) => {
    addInsurance(data);
  };

  const callBackGetInsurerTypes = (data: any) => {
    setAllInsurers(data);
  };
  const callBackGetPolicyTypes = (data: any) => {
    setAllPolicies(data);
  };

  async function addInsurance(data: any) {
    if (selector && data) {
      const empId: any = selector.emp_id;
      const formData = new FormData();

      formData.append("emp_id", empId);
      formData.append("dependent_id", insuranceList?.id);
      formData.append("insurer", data.insurer);
      formData.append("policy_type", data.policy_type);
      formData.append("policy_number", data.policy_number);
      formData.append("start_date", data.start_date);
      formData.append("end_date", data.end_date);
      formData.append("category", data.category);
      formData.append("amount", data.amount);
      if (data?.newattachement) {
        formData.append("attachments", data.attachments);
      }
      await dependentsServices
        .addInsurance(formData)
        .then((response) => {
          if (response.response == "success") {
            dispatch(setAlldependentslist(response.data));
            toast.success(trans("Insurance Added Successfully"));
            mainModel(false);
          }
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        });
    }
  }

  return (
    <div>
      <DTOAddInsurance
        setAllInsurerTypesData={callBackGetInsurerTypes}
        setAllPolicyTypesData={callBackGetPolicyTypes}
      />

      <AddInsurancePresenter
        callBackGetData={getData}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        allInsurerTypes={allInsurers}
        allPolicyTypes={allPolicies}
        trans={trans}
      />
    </div>
  );
};

export default AddInsuranceController;
